import { useRef } from "react";
import { Fab, Menu } from "@mui/material";
import { ReactComponent as ChatIcon } from "@/Washouts/assets/icons/chatIcon.svg";
import { IChat, IGetChangeRequest } from "@/Washouts/types/PayrollClosing/queries";
import ChatHeader from "./chatHeader";
import ChatBody from "./chatBody";
import { IInput } from "@/Common/api/types/ChangeRequests";

type TChangeRequestChatProps = {
	selectedRowId: string | null;
	isVisible: boolean;
	isOpen: boolean;
	isEscalated: boolean;
	title: string;
	disableAllActions: boolean;
	hideOpenWashout: boolean;
	hideEscalateAction: boolean;
	disableStatusAction: boolean;
	messages: IChat[];
	userId?: string;
	locationId?: string;
	commissionCycleId?: string;
	payPeriodId?: string;
	position?: string;
	statusActionTooltipText?: string;
	canEditWashout: boolean;
	pending: { isPending: boolean; mutationAction: string };
	selectedRow: IGetChangeRequest | null;
	handleUpdate: (input: IInput, action: string, files?: File[]) => void;
	toggleOpenChat: () => void;
	closeChat: () => void;
};
const ChangeRequestChat = (props: TChangeRequestChatProps) => {
	const {
		selectedRowId,
		isVisible,
		isOpen,
		toggleOpenChat,
		isEscalated,
		title,
		closeChat,
		messages,
		disableAllActions = false,
		hideOpenWashout = false,
		hideEscalateAction = false,
		disableStatusAction = false,
		userId = "",
		locationId = "",
		commissionCycleId = "",
		payPeriodId = "",
		position = "",
		statusActionTooltipText,
		canEditWashout,
		handleUpdate,
		pending,
		selectedRow,
	} = props;
	const buttonRef = useRef(null);

	const fabClasses = `!bg-primary !text-white !hover:cursor-pointer ${isOpen ? "!rounded-t-none" : "!rounded-full"}`;

	const lockBody = () => {
		document.body.style.overflow = "hidden";
	};

	const unlockBody = () => {
		document.body.style.overflow = "";
	};

	if (isOpen) {
		lockBody();
	} else {
		unlockBody();
	}

	return (
		<>
			<Menu
				variant="menu"
				anchorEl={buttonRef.current}
				open={isOpen}
				onClose={toggleOpenChat}
				disableScrollLock
				slotProps={{
					paper: {
						elevation: 0,
						sx: {
							overflow: "visible",
							filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
							borderRadius: "10px 10px 0px 10px",
							height: "580px",
							width: "515px",
						},
					},
				}}
				transitionDuration={100}
				transformOrigin={{ horizontal: "right", vertical: "bottom" }}
				anchorOrigin={{ horizontal: "right", vertical: "top" }}
			>
				<ChatHeader isEscalated={isEscalated} title={title} toggleOpenChat={toggleOpenChat} closeChat={closeChat} />
				<ChatBody
					selectedRowId={selectedRowId}
					data={messages}
					disableAllActions={disableAllActions}
					hideOpenWashout={hideOpenWashout}
					hideEscalateAction={hideEscalateAction}
					disableStatusAction={disableStatusAction}
					userId={userId}
					locationId={locationId}
					commissionCycleId={commissionCycleId}
					payPeriodId={payPeriodId}
					position={position}
					handleUpdate={handleUpdate}
					pending={pending}
					statusActionTooltipText={statusActionTooltipText}
					canEditWashout={canEditWashout}
					selectedRow={selectedRow}
				/>
			</Menu>
			<Fab
				ref={buttonRef}
				onClick={toggleOpenChat}
				className={fabClasses}
				style={{
					padding: 0,
					zIndex: 1100,
					position: "fixed",
					bottom: 10,
					right: 100,
					top: "unset",
					left: "unset",
					visibility: isVisible ? "visible" : "hidden",
				}}
			>
				<ChatIcon fontSize="small" />
			</Fab>
		</>
	);
};

export default ChangeRequestChat;
